/**
 * Date/time utilities for Manna Trust
 *
 * All timestamps from the backend are UTC but stored without timezone indicator.
 * These helpers force UTC interpretation then display in IST (Asia/Kolkata, UTC+5:30).
 */

/** Ensure a datetime string is treated as UTC (append Z if missing timezone). */
function toUtcDate(dateStr) {
  if (!dateStr) return null;
  const s = String(dateStr).trim();
  // Already has timezone marker?
  if (s.endsWith("Z") || /[+-]\d{2}:\d{2}$/.test(s)) return new Date(s);
  // No marker — treat as UTC by appending Z
  return new Date(s + "Z");
}

const IST_OPTS = { timeZone: "Asia/Kolkata" };

/** Format: "11 Jun, 08:25 am" */
export function fmtDateTime(dateStr) {
  const d = toUtcDate(dateStr);
  if (!d || isNaN(d)) return dateStr || "";
  return d.toLocaleString("en-IN", {
    ...IST_OPTS,
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Format: "11 Jun 2026, 08:25 am" */
export function fmtDateTimeLong(dateStr) {
  const d = toUtcDate(dateStr);
  if (!d || isNaN(d)) return dateStr || "";
  return d.toLocaleString("en-IN", {
    ...IST_OPTS,
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Format: "08:25 am" */
export function fmtTime(dateStr) {
  const d = toUtcDate(dateStr);
  if (!d || isNaN(d)) return dateStr || "";
  return d.toLocaleTimeString("en-IN", {
    ...IST_OPTS,
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Format: "11/06/2026" */
export function fmtDate(dateStr) {
  const d = toUtcDate(dateStr);
  if (!d || isNaN(d)) return dateStr || "";
  return d.toLocaleDateString("en-IN", {
    ...IST_OPTS,
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
